import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 90vh;
  min-height: 40vh;
  overflow: hidden;
  outline: none;
  
  &:focus-visible {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
`;

export const MessageContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e3f2fd;
  margin-bottom: 24px;
  
  svg {
    color: #1976d2;
  }
`;

export const MessageTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
`;

export const MessageText = styled.p`
  margin: 0 0 24px 0;
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
  max-width: 500px;
`;

export const InfoText = styled.p`
  margin: 4px 0;
  font-size: 0.875rem;
  color: #888;
  
  strong {
    color: #555;
  }
`;
